export default "__VITE_ASSET__50d3e514__"